import { I18nUtils } from '@medable/i18n-core';
import { Locale } from 'libs.i18n-core';
const PSEUDO_LOCALE_LABELS = {
    [Locale.en_XA]: 'Pseudo (en-XA)',
    [Locale.ar_XB]: 'Pseudo RTL (ar-XB)',
};
/**
 * Formats a locale option for the locales dropdown
 * @param locale - The locale to format
 * @param currentLocale - The current locale
 * @param forceI18nFormat - Whether to force the locale to be in i18n format from any potential cortex formats
 * @returns SelectOption
 */
export const formatLocaleOption = (locale, currentLocale) => {
    const showOwnLocale = true;
    const value = I18nUtils.cortexToI18nFormat(locale);
    return {
        value,
        label: PSEUDO_LOCALE_LABELS[value] || I18nUtils.getLanguageLabel(locale, currentLocale, showOwnLocale),
    };
};
export const formatLocaleList = (locales, currentLocale) => {
    return locales.length ? locales.map((locale) => formatLocaleOption(locale, currentLocale)) : [];
};
